import apiFetchPost from "./ClientAPI";

export async function apiPostWithLogging<Req, Res>(
  url: string,
  data: Req,
  errorMessage: string
): Promise<Res> {
  try {
    return await apiFetchPost<Req, Res>(url, data);
  } catch (error) {
    console.error(errorMessage, error);
    return Promise.reject(error);
  }
}


